<template>
  <div>
    <el-dialog width="500px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible" class="reset-dialog">
      <!-- <div class="success-div">
      <span class="success-child"></span>
    </div> -->
      <h1>{{$t(`setting.resetPwd`)}}</h1>
      <p class="tip">{{$t('setting.resetPwdTip', {'email': mt5Info.email})}}</p>
      <!-- <p>{{$t('setting.confirm.p2')}}</p> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="submit-button" @click="submitForm('form')" test_id="setting_back_login">
          {{$t('common.ok')}}</el-button>
        <el-button type="primary" class="el-button--cencel" @click="cancle('form')" test_id="setting_back_login">
          {{$t('common.cancel')}}</el-button>
      </div>
    </el-dialog>
    <success id="mt5Success" title="commitSuccess" tip="commitSuccessTip" :tipObj="{email: mt5Info.email}" :visible.sync="successVisible" page_id="page_setting_success_confirm"></success>
  </div>

</template>
<script>
// import store from '@/store'
// import SecurityService from '@/js/util/SecurityService.js'
import success from './success'
import tradeApi from '@/api/v2/trade.js'
export default {
  data () {
    return {
      formLabelWidth: '120px',
      labelPosition: 'top',
      successVisible: false
    }
  },
  props: ['visible', 'mt5Info'],
  components: {
    success
  },
  methods: {
    submitForm (formName) {
      // this.dialogFormVisible = false
      // this.$emit('update:visible', false)
      // // this.$router.push('/login');
      // const oAuth = new SecurityService()
      // oAuth.signOut()
      let params = {
        tradeAccountNumber: this.mt5Info.tradeAccountNumber
      }
      tradeApi.resetMt5Password(params).then(res => {
        if (res.code === 200) {
          this.$emit('update:visible', false)
          this.successVisible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    cancle () {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
h1,
p {
  text-align: center;
}
h1 {
  font-size: 22px;
  font-weight: 600;
  color: #24282d;
  margin-bottom: 20px;
}

.dialog-footer {
  width: 60%;
  height: 3rem;
  margin: 1rem auto 100px auto;
}
.success-div {
  margin: auto;
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  background-color: rgba(254, 192, 0, 1);
  margin-bottom: 20px;
}
.success-child {
  position: relative;
  width: 81px;
  height: 81px;
}

.success-child::after {
  position: absolute;
  top: 0.7rem;
  left: 1.5rem;
  width: 1.5rem;
  height: 2.5rem;
  border-style: solid;
  border-color: white;
  border-width: 0 5px 5px 0;
  transform: rotateZ(45deg);
  content: "";
}
.tip {
  font-size: 14px;
  color: #24282d;
}
.reset-dialog {
  /deep/ .el-dialog__body {
    padding: 0 125px;
  }
  @media (max-width: 768px) {
    /deep/ .el-dialog__body {
      padding: 0 50px;
    }
  }
}
.submit-button {
  width: 100%;
  height: 100%;
  margin: auto;
  height: 56px;
  color: black !important;
  border: 1px solid rgba(255, 255, 255, 0);
  margin-bottom: 20px;
}
.el-button--cencel {
  width: 100%;
  color: #192b57;
  font-weight: bold;
  height: 56px;
  border-color: #192b57;
  background-color: #fff;
  margin-left: 0;
}
</style>
